import { createStore } from "redux";
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import rootReducer from './Reducers';

const persistConfig = {
  // 存储在 localStorage 中的键名
  key: 'root',
  // 使用 localStorage 作为存储介质
  storage,
  // 指定需要持久化的 reducer 键名
  whitelist: [],
}
// 创建一个持久化的 reducer
const persistedReducer = persistReducer(persistConfig, rootReducer);
// 创建 Redux store
const store = createStore(persistedReducer);
// 创建持久化存储
const persistor = persistStore(store)

export { 
  persistor, 
  store 
}